import axios from 'axios'
import GetCookie from '../sharedComponents/src/globalHeader/common/getCookie'
import { tokenCookieKey } from '../sharedComponents/src/globalHeader/functions/ams-functions'
import { MISSIONS_URL as API_URL } from '../env'

export const missionsApi = axios.create({
    baseURL: `${API_URL}/api/`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})

// Add a request interceptor
missionsApi.interceptors.request.use(
    async (config) => {
        // Bearer as well as the cookie: WebViews and cookie-blocking browsers may not deliver the jwt cookie here
        const token = GetCookie(tokenCookieKey)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// Add a response interceptor
missionsApi.interceptors.response.use(
    (response) => response,
    async (error) => {
        // A 401 goes back to the caller untouched: renewToken() deletes the jwt cookie when it fails,
        // so calling it from here would turn a missions 401 into a lost session
        return Promise.reject(error)
    },
)
